import { signOutClickHandler } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useMsal } from "@azure/msal-react";

const SignOutMenuItem = () => {
  const { instance } = useMsal();
  const { user } = useAppSelector((state) => state.system);

  return (
    <button
      className="mb-2 mt-auto px-8 py-4 text-start text-sm uppercase text-white"
      onClick={() => signOutClickHandler(instance, user?.id as string)}
    >
      Sign Out
    </button>
  );
};

export default SignOutMenuItem;
